var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, css, html, property, LitElement } from 'lit-element';
let TcCustomSelectOption = class TcCustomSelectOption extends LitElement {
    constructor() {
        super();
        this.name = '';
        this.value = '';
        this.selected = false;
    }
    static get styles() {
        return css `
            * {
                box-sizing: border-box;
            }

            .option {
                position: relative;
                cursor: pointer;
                display: flex;
                gap: 1rem;
                align-items: center;
                transition: color 0.2s ease-out;
            }

            .option label {
                width: 100%;
                padding: 6px 0;
                cursor: pointer;
                display: flex;
                gap: 1rem;
                align-items: center;
                font-family: Montserrat, sans-serif;
                text-align: left;
                text-transform: capitalize;
                font-weight: 500;
            }

            .option:hover {
                color: var(--color-primary);
            }

            .option:hover input:checked ~ label::after {
                border-color: var(--color-primary-dark);
            }

            .option input:checked ~ label::after {
                border-style: solid;
                border-color: var(--color-primary);
                border-width: 0.17em 0.17em 0 0;
                content: '';
                display: inline-block;
                height: 0.55em;
                right: -4px;
                position: absolute;
                top: 10px;
                transform: rotate(135deg);
                vertical-align: top;
                width: 0.95em;
                transition: border-color 0.3s ease-out;
            }

            .option input:checked ~ label {
                font-weight: 600;
            }

            .option input:focus ~ label {
                color: var(--color-primary);
            }

            .option input[type='radio'] {
                position: absolute;
                left: 0;
                opacity: 0;
            }
        `;
    }
    change(event) {
        event.preventDefault();
        this.dispatchEvent(new CustomEvent('change', {
            detail: {
                value: this.value,
            },
            bubbles: true,
        }));
    }
    render() {
        return html `
            <div class="option" role="option">
                <input
                    type="radio"
                    id="option-${this.name}"
                    name="option-${this.name}"
                    @change="${this.change}"
                    ?checked="${this.selected}"
                />
                <label for="option-${this.name}">${this.name}</label>
            </div>
        `;
    }
};
__decorate([
    property({ type: String })
], TcCustomSelectOption.prototype, "name", void 0);
__decorate([
    property({ type: String })
], TcCustomSelectOption.prototype, "value", void 0);
__decorate([
    property({ type: Boolean })
], TcCustomSelectOption.prototype, "selected", void 0);
TcCustomSelectOption = __decorate([
    customElement('tc-custom-select-option')
], TcCustomSelectOption);
export default TcCustomSelectOption;
